export default __webpack_public_path__ + "821f5581b71be0f10963c91220d26173.png";